function focusRing() {

	document.body.classList.add("no-focus-outline");

	document.body.addEventListener('keyup', function(e) {
		if (e.which === 9) /* tab */ {
			document.body.classList.remove('no-focus-outline');
		}
	});

	document.body.addEventListener('click', function(e) {
		document.body.classList.add('no-focus-outline');
	});
	
};

export default focusRing;